var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Search---OnHover",
    transform: "translate(-490.000000, -208.000000)",
    fill: "#003952",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Search_1408266",
    transform: "translate(490.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8690039,14.8697598 C16.7119605,15.0769278 16.7334852,15.3937039 16.9229599,15.5831786 L23.4067328,22.0669515 C23.7767031,22.4369219 23.7767031,23.0367623 23.4067328,23.4067328 C23.0367623,23.7767031 22.4369219,23.7767031 22.0669515,23.4067328 L15.5831786,16.9229599 C15.3963362,16.7361175 15.0763093,16.7136452 14.8675794,16.8702849 C14.8675794,16.8702849 14.789267,16.9374601 14.5491063,17.0976585 C13.0963619,18.0667071 11.3509895,18.6315789 9.47368421,18.6315789 C4.41591859,18.6315789 0.315789474,14.5314498 0.315789474,9.47368421 C0.315789474,4.41591859 4.41591859,0.315789474 9.47368421,0.315789474 C14.5314498,0.315789474 18.6315789,4.41591859 18.6315789,9.47368421 C18.6315789,11.3583837 18.0622485,13.1101089 17.0861893,14.5662585 C16.9292943,14.8003249 16.8690039,14.8697598 16.8690039,14.8697598 Z M9.47368421,16.7368421 C13.4850155,16.7368421 16.7368421,13.4850155 16.7368421,9.47368421 C16.7368421,5.46235288 13.4850155,2.21052632 9.47368421,2.21052632 C5.46235288,2.21052632 2.21052632,5.46235288 2.21052632,9.47368421 C2.21052632,13.4850155 5.46235288,16.7368421 9.47368421,16.7368421 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d7e205290eb0b69f4cd908025a5f396b.svg";
export { ForwardRef as ReactComponent };